import React from 'react';
import {
    Table,
    TableHeader,
    TableHeaderCell,
    TableRow,
} from 'semantic-ui-react';
import ProfessorTitle from '../common/titles/ProfessorTitle';

const ProfessorsWithSimilarNamesTable = ({ similarProfessors }) => {
    return (
        <Table striped compact>
            <TableHeader>
                <TableRow>
                    <TableHeaderCell>Prof. Name</TableHeaderCell>
                    <TableHeaderCell>Prof. UNI</TableHeaderCell>
                </TableRow>
            </TableHeader>

            {similarProfessors.map((professor, index) => {
                return (
                    <TableRow>
                        <Table.Cell>
                            <ProfessorTitle
                                professor={professor.professor_header}
                                includeBadge={false}
                            />
                        </Table.Cell>
                        <Table.Cell>
                            {professor.professor_header.uni || 'Missing'}
                        </Table.Cell>
                    </TableRow>
                );
            })}
        </Table>
    );
};

export default ProfessorsWithSimilarNamesTable;
